import { PanelSection } from '../SidePanel';
import { unitForValue } from '../../utils/formatters';
import { LabeledData } from './menu-components';

const Section = ({ count, content, label }) =>
  !!count && (
    <PanelSection>
      <h4 className="text-capitalize">{label}</h4>
      <LabeledData
        copyable
        label="qty"
        unit={unitForValue(label, label.slice(0, -1))}
      >
        {count}
      </LabeledData>
      {content}
    </PanelSection>
  );

const CustomLayerInspectSections = ({
  inspectMainContent,
  areaStatsContent,
  lengthStatsContent,
  polygonsCount,
  linesCount,
  pointsCount,
}) => {
  return (
    <>
      <PanelSection>{inspectMainContent}</PanelSection>
      <Section
        label="polygons"
        count={polygonsCount}
        content={areaStatsContent}
      />
      <Section label="lines" count={linesCount} content={lengthStatsContent} />
      <Section label="points" count={pointsCount} />
    </>
  );
};

export default CustomLayerInspectSections;
